import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, concatMap, switchMap, first, mergeMap } from 'rxjs/operators';
import { Observable, of, pipe } from 'rxjs';
import { AuthenticationProvider, SigninModel, UserIdentity, OrganizationDto } from '../../../types';
import { EnvironmentDescriptor, Environment } from '../../../../environment/types';

@Injectable()
export class DefaultAuthenticationProviderService implements AuthenticationProvider {
    baseUrl = '';
    // baseUrl = 'security/';

    constructor(
        @Inject(Environment) private env: EnvironmentDescriptor,
        private httpClient: HttpClient,
        private injector: Injector
    ) {
    }

    changeUserPassword(currentPassword: string, newPassword: string): Observable<any> {
        return this.httpClient.post<any>(this.baseUrl + 'login', {
            pass: currentPassword,
            newPassword
        });
    }

    getCaptcha(): Observable<Blob> {
        return this.httpClient.post(this.baseUrl + 'resources/get-captcha', {}, { responseType: 'blob' });
    }

    signIn(signinModel: SigninModel) {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Basic ${btoa('navaco-client' + ':' + 'navaco-secret')}`);
        const body = new FormData();
        body.append('username', signinModel.username);
        body.append('password', signinModel.password);
        body.append('captcha', signinModel.captcha);
        body.append('grant_type', 'password');
        return this.httpClient.post<any>(this.baseUrl + 'auth/login', body, { headers })
            .pipe(
                concatMap(res => this.httpClient.post('resources/set-cokie', {}))
            );
    }

    getUser(): Observable<UserIdentity> {
        return this.httpClient.post<any>(this.baseUrl + 'api/users/get-user-info', {})
            .pipe(
                map(x => {
                    return new UserIdentity(
                        x.firstName,
                        x.lastName,
                        x.activities,
                        x.forcePasswordChange,
                        x.activeOrganization ? x.activeOrganization.id : null,
                        x.activeOrganization ? x.activeOrganization.title : null);
                })
            );
    }

    getUserOrganizations(): Promise<OrganizationDto[]> {
        return this.httpClient.post<any>(this.baseUrl + 'api/users/get-user-orgs', {}).toPromise();
    }

    setUserOrganization(organizationId: number) {
        return this.httpClient.post<any>(this.baseUrl + 'api/users/set-active-org', organizationId);
    }

    refreshAuthToken(): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'refreshToken', 1)
            .pipe(
                map(res => true)
            );
    }

    signOut() {
        return this.httpClient.post(this.baseUrl + 'api/users/logout', {})
            .pipe(
                map(res => true)
            );
    }
}
